export const ROUTES = {
  INDEX: '/',
  // static
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_SERVICE: '/terms-of-service',
  PRICING: '/pricing',
  // auth
  FREE_TRIAL: '/free-trial',
  FREE_TRIAL_ONLINE_LEARNING: '/online-learning-free-trial',
  SIGN_IN: '/sign-in',
  SIGN_OUT: '/sign-out',
  RESET_PASSWORD: '/reset-password',
  // main pages
  EXPLORE: '/explore',
  EXPLORE_TOPICS: '/explore/topics',
  SCHOOLS: '/schools',
  CLASSES: '/classes',
  USERS: '/users',
  INVITES: '/invites',
  // settings
  SETTINGS: '/settings',
  SETTINGS_ACCOUNT: '/settings/account',
  SETTINGS_CHANGE_PASSWORD: '/settings/change-password',
  SETTINGS_EMAIL_UNSUBSCRIBE: '/settings/email-subscriptions/unsubscribe',
  SETTINGS_SUBSCRIPTION: '/settings/subscription',
  SETTINGS_PAYMENT: '/settings/payment',
  SETTINGS_SUBSCRIPTION_PAYMENT: '/settings/subscription/payment',
  SETTINGS_SUBSCRIPTION_ACTIVATION: '/settings/subscription/activation',
  SETTINGS_SUBSCRIPTION_CONFIRMATION: '/settings/subscription/confirmation',
  ERROR_EXPIRED_TRIAL: '/error/expired-trial',
  // subscription
  SUBSCRIPTION: '/subscription',
  SUBSCRIPTION_USERNAME: '/subscription/username',
  SUBSCRIPTION_LOGIN: '/subscription/login',
  SUBSCRIPTION_CREATE_ACCOUNT: '/subscription/create-account',
  SUBSCRIPTION_PAYMENT: '/subscription/payment',
  // admin
  ADMIN_STATS: '/admin/stats',
  ADMIN_STATS_GENERIC: '/admin/stats/generic',
  // admin v2
  ADMIN_V2: '/admin-v2',
  ADMIN_V2_STATS_SCHOOLS: '/admin-v2/stats/schools',
  ADMIN_V2_STATS_EDUCATORS: '/admin-v2/stats/educators',
  ADMIN_V2_STATS_GRAPHS: '/admin-v2/stats/graphs',
};
